<app-page-title title="devocional"></app-page-title>
<mat-progress-bar mode="indeterminate" *ngIf="showLoader"></mat-progress-bar>

<app-no-data
  *ngIf="devocional.length == 0 && !showLoader"
  title="Sem dados"
  subtitle="Nenhum quiz encontrado"
></app-no-data>

<div class="cards-container" *ngIf="devocional.length > 0">
  <div class="quiz-card" *ngFor="let quiz of devocional">
    <div class="card-header">
      <h3 class="quiz-title" [routerLink]="['/devocional/view', quiz.id]">{{ quiz.title }}</h3>

      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        *ngIf="hasPermission('quiz.edit') || hasPermission('quiz.delete')"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item *ngIf="hasPermission('quiz.edit')" [routerLink]="['/devocional/form', quiz.id]">
          <mat-icon>edit</mat-icon>
          <span>Editar</span>
        </button>
        <button mat-menu-item *ngIf="hasPermission('quiz.delete')" (click)="delete(quiz.id, quiz.title)">
          <mat-icon>delete</mat-icon>
          <span>Excluir</span>
        </button>
      </mat-menu>
    </div>

    <div class="card-body" [routerLink]="['/devocional/view', quiz.id]">
      <p class="quiz-text">{{ quiz.text }}</p>
    </div>

    <div class="card-footer" [routerLink]="['/devocional/view', quiz.id]">
      <div class="status-container" *ngIf="quiz.my_answered; else notAnswered">
        <mat-icon class="status-icon answered">check_circle</mat-icon>
        <span class="status-text answered-text">Respondido</span>
      </div>

      <ng-template #notAnswered>
        <div class="status-container">
          <mat-icon class="status-icon" [ngClass]="{ expired: isExpired(quiz.end_date) }">event</mat-icon>
          <span class="status-text" [ngClass]="{ 'expired-text': isExpired(quiz.end_date) }">
            {{ isExpired(quiz.end_date) ? 'Encerrou em:' : 'Encerra em:' }} {{ quiz.end_date | date : 'dd/MM/yyyy' }}
          </span>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<div class="floating-btn-container" *ngIf="hasPermission('quiz.create')">
  <button mat-fab color="primary" [routerLink]="['/devocional/form/new']">
    <img src="../../../assets/icons/add_white_24dp.svg" />
  </button>
</div>
